"use client";
import parse from "html-react-parser";
import "swiper/css";
import "swiper/css/pagination";

interface GenericSection {
  title: string;
  description?: string;
  cards: { title: string; desc: string }[];
  header?: string;
  footer?: string;
}

const GenericSection: React.FC<GenericSection> = ({
  title,
  description,
  header,
  footer,
  cards,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 w-full justify-items-stretch pb-6">
      <div className="col-span-1 lg:col-span-4 flex flex-col gap-y-4 text-neutral-light-900">
        <h2 className=" font-semibold text-neutral-light-50 font-poppins">
          {parse(title)}
        </h2>
      </div>
      <div className="col-span-1 lg:col-span-8 flex flex-col gap-6 lg:gap-8">
        <div className="flex flex-col text-neutral-light-900 text-sm lg:text-base font-normal gap-y-5">
          <p>{parse(header || "")}</p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {cards.map((item, index) => (
              <div
                key={index}
                className="bg-dark-neutral-50 flex flex-col gap-y-3 p-4 lg:p-8 text-neutral-light-800 text-lg font-medium border-[1px] border-dark-neutral-200 rounded-lg"
              >
                <div className="text-light-neutral-200 text-base lg:text-xl font-semibold">
                  {item?.title}
                </div>
                <p className="text-sm lg:text-base">{parse(item?.desc)}</p>
              </div>
            ))}
          </div>
          <p>{footer}</p>
        </div>
      </div>
    </div>
  );
};

export default GenericSection;
